<template>
    <div class="autocomplete">
        <ul class="autocomplete-results" v-show="result.length">
            <li @click="selectItem(i)" class="autocomplete-result" v-for="(i, index) of result" :v-key="index">
                {{ i.value }}
            </li>
        </ul>
    </div>
</template>

<script>
  import {get} from '@/api';

  export default {
    name: 'autocomplete',
    props: {
      result: {
        type: Array
      }
    },
    data() {
      return {};
    },

    methods: {
      selectItem(i) {
        this.$emit('selected', i);
      }
    }
  };
</script>

<style scoped>
    .autocomplete {
        width: 100%;
    }

    .autocomplete-results {
        padding: 10px 0;
        margin: 0;
        border: 1px solid #eeeeee;
        max-height: 120px;
        overflow-y: auto;
        background: #fff;
        position: absolute;
        z-index: 3;
        width: 100%;
        height: 500px;
        box-shadow: 4px 5px 7px rgba(0,0,0,0.1);

    }

    .autocomplete-results li {
        padding: 6px 10px;
    }

    .autocomplete-result {
        list-style: none;
        text-align: left;
        padding: 6px 4px;
        cursor: pointer;
        color: #1b1e21;
    }

    .autocomplete-result:hover {
        background-color: #f8f9fa;
        color: #16181b;
    }
</style>



// WEBPACK FOOTER //
// src/views/Common/AutoComplete/AutoCompleteResult.vue